import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { withRouter } from 'react-router-dom'
import { BREAKPOINT_EXTRA_SMALL, BREAKPOINT_LARGE } from '../constants'
import Sticky from 'react-stickynode'
import { me } from '../initial_state'
import {
  CX,
} from '../constants'
import { expandMediaAttachmentsByAccountId } from '../actions/media_attachments'
import DefaultNavigationBar from '../components/navigation_bar/default_navigation_bar'
import FooterBar from '../components/footer_bar'
import ProfileHeader from '../components/profile_header'
import FloatingActionButton from '../components/floating_action_button'
import ProfileNavigationBar from '../components/navigation_bar/profile_navigation_bar'
import LoggedOutNavigationBar from '../components/navigation_bar/logged_out_navigation_bar'
import Responsive from '../features/ui/util/responsive_component'
import Divider from '../components/divider'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  ProfileStatsPanel,
  ProfileInfoPanel,
  MediaGalleryPanel,
  SignUpPanel,
  SidebarXS,
  AccountMarketplaceListingsPanel,
  TopFriendsPanel,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'
import HomeCallToAction from '../components/home_call_to_action'

class ProfileLayout extends ImmutablePureComponent {

  render() {
    const {
      account,
      children,
      titleHTML,
      unavailable,
      noSidebar,
      width,
    } = this.props

    const isXS = width <= BREAKPOINT_EXTRA_SMALL

    const mainContentClasses = CX({
      d: 1,
      statusWidthSidebarPage: !noSidebar,
      w100PC: noSidebar,
      z1: 1,
    })

    const mentionText = !!account && account.get('id') !== me ? `@${account.get('acct')} ` : ''
    const isTimeline = this.props.match.path === "/:username"
    const mediaGalleryParams = {
      id: !!account ? account.get('id') : -1,
      type: 'account',
      to: !!account ? `/${account.get('acct')}/photos` : null,
      onExpand: expandMediaAttachmentsByAccountId,
    }
    const mediaGalleryParams1 = {
      ...mediaGalleryParams,
      title: 'Photos',
      params: { mediaType: 'image' },
      to: !!account ? `/${account.get('acct')}/photos` : null,
    }
    const mediaGalleryParams2 = {
      ...mediaGalleryParams,
      title: 'Videos',
      params: { mediaType: 'video' },
      to: !!account ? `/${account.get('acct')}/videos` : null,
    }

    return (
      <div className={[_s.d, _s.w100PC, _s.minH100VH, _s.bgTertiary].join(' ')}>

        { isXS && <WrappedBundle component={SidebarXS} /> }

        { isXS &&
          <>
            { !me &&  <LoggedOutNavigationBar isProfile /> }

            <main role='main' className={[_s.d, _s.w100PC].join(' ')}>

              <div className={[_s.d, _s.w100PC, _s.flexRow, _s.pb15].join(' ')}>

                <div className={[_s.d, _s.w100PC, _s.flexRow, _s.jcSpaceBetween].join(' ')}>
                  <div className={[_s.d, _s.z1, _s.w100PC, _s.aiCenter].join(' ')}>

                    <ProfileHeader account={account} isXS>
                      <WrappedBundle component={ProfileInfoPanel} componentParams={{ account, noPanel: true }} />
                      <WrappedBundle component={ProfileStatsPanel} componentParams={{ account, noPanel: true }} />
                    </ProfileHeader>

                    <div className={[_s.d, _s.w100PC, _s.jsCenter, _s.py15].join(' ')}>
                      <WrappedBundle component={TopFriendsPanel} componentParams={{ account, isXS }} />

                      <div className={[_s.d, _s.w100PC, _s.z1].join(' ')}>
                        { (!unavailable && isTimeline) && <WrappedBundle component={AccountMarketplaceListingsPanel} componentParams={{ account, scroll: 'x' }} /> }
                        <div className={[_s.d, _s.boxShadowNone].join(' ')}>
                          {children}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>


              </div>

              <FloatingActionButton text={mentionText} />

            </main>

            <FooterBar />
          </>
        }

        {
          !isXS &&
          <>
            {
              me &&
              <DefaultNavigationBar />
            }
            {
              !me &&
              <LoggedOutNavigationBar isProfile />
            }

            <main role='main' className={[_s.d, _s.w100PC].join(' ')}>

              <div className={[_s.d, _s.w100PC, _s.flexRow, _s.pb15].join(' ')}>

                <div className={[_s.d, _s.w100PC, _s.flexRow, _s.jcSpaceBetween].join(' ')}>
                  <div className={[_s.d, _s.z1, _s.w100PC, _s.aiCenter].join(' ')}>

                    <ProfileHeader account={account} />

                    <div className={[_s.d, _s.w100PC, , _s.flexRow, _s.jcCenter, _s.py15].join(' ')}>
                      {
                        !noSidebar &&
                        <div className={[_s.d, _s.w380PX, _s.mr15].join(' ')}>
                          <Sticky top={63} enabled>
                            <div className={[_s.d, _s.w380PX].join(' ')}>
                              <WrappedBundle component={ProfileStatsPanel} componentParams={{ account }} />
                              <WrappedBundle component={TopFriendsPanel} componentParams={{ account }} />
                              <WrappedBundle component={ProfileInfoPanel} componentParams={{ account }} />
                              { !unavailable && !!me && <WrappedBundle component={MediaGalleryPanel} componentParams={mediaGalleryParams1} /> }
                              { !unavailable && !!me && <WrappedBundle component={MediaGalleryPanel} componentParams={mediaGalleryParams2} /> }
                              { !unavailable && <WrappedBundle component={AccountMarketplaceListingsPanel} componentParams={{ account, scroll: 'y' }} /> }
                              { !me && <WrappedBundle component={SignUpPanel} /> }
                              { !me && <HomeCallToAction isXS={isXS} /> }
                              <WrappedBundle component={LinkFooter} />
                            </div>
                          </Sticky>
                        </div>
                      }
                      <div className={mainContentClasses}>
                        <div className={_s.d}>
                          {children}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>


              </div>

              <FloatingActionButton text={mentionText} />

            </main>
          </>
        }

      </div>
    )
  }

}

const mapStateToProps = state => ({
  width: state.getIn(['settings', 'window_dimensions', 'width'])
})

ProfileLayout.propTypes = {
  account: ImmutablePropTypes.map,
  children: PropTypes.node.isRequired,
  titleHTML: PropTypes.string,
  unavailable: PropTypes.bool,
  noSidebar: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps)(ProfileLayout))